import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("TabItemWidget", {
  title: "Single Tab",
  properties: ["headline"],
});
